import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { cachedGet } from '../lib/api';
import { useLang } from '../contexts/LanguageContext';
import RecipeCard from '../components/RecipeCard';

export default function Category() {
  const { id } = useParams();
  const { t, lang } = useLang();
  const [recipes, setRecipes] = useState([]);
  const [cat, setCat] = useState(null);

  useEffect(() => {
    cachedGet('/recipes', { params: { category: id } }).then(({ data }) => setRecipes(data));
    cachedGet('/categories').then(({ data }) => setCat(data.find(c => c.id === id)));
  }, [id]);

  return (
    <div className="space-y-6" data-testid="category-page">
      <Link to="/" className="inline-flex items-center gap-1 text-sm text-[#5C4D44] hover:text-[#C05A42] transition" data-testid="back-home">
        <ChevronLeft className="h-4 w-4 rtl:rotate-180" /> {t('backHome')}
      </Link>
      {cat && (
        <div className="relative overflow-hidden rounded-3xl h-48 sm:h-64">
          <img src={cat.image} alt="" className="absolute inset-0 w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/65 to-transparent" />
          <h1 className="absolute bottom-6 start-6 text-3xl sm:text-4xl text-white font-display font-bold drop-shadow-md">
            {lang === 'ar' ? cat.name_ar : cat.name_en}
          </h1>
        </div>
      )}
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {recipes.map((r, i) => <RecipeCard key={r.recipe_id} recipe={r} index={i} />)}
      </div>
    </div>
  );
}
